module.exports = __webpack_public_path__ + "efedbf0206aa868845d4c9259be97c47.png";